import { parse } from 'papaparse';

export const headerValidation = (parsedData, requiredFields) => {
  if (parsedData.length === 0) {
    return [];
  }

  // OR semantics: if requiredFields[0] is an array, treat the top-level
  // array as a list of alternatives. Validation passes if any alternative
  // has all its fields present. Returns the shortest missing-fields list.
  if (Array.isArray(requiredFields[0])) {
    const missingPerAlternative = requiredFields.map((alternative) =>
      alternative.filter((field) => !parsedData.includes(field))
    );
    const passing = missingPerAlternative.filter((missing) => missing.length === 0);
    if (passing.length > 0) {
      return [];
    }
    // If the operator started matching one alternative (some but not all of its
    // fields present), report that closest alternative's remaining fields.
    const partiallyMatched = missingPerAlternative.find(
      (missing, index) => missing.length > 0 && missing.length < requiredFields[index].length
    );
    if (partiallyMatched) {
      return partiallyMatched;
    }
    // No alternative matched at all — make the OR-choice explicit so operators
    // who only know one column name (e.g. email) aren't told to add the other.
    const orDescription = requiredFields.map((alternative) => alternative.join(' + ')).join(' OR ');
    return [`one of: ${orDescription}`];
  }

  // AND semantics: original behavior
  return requiredFields.filter((field) => !parsedData.includes(field));
};

export const parseHandler = (values, setOpen, setMissingFields, requiredFields) => {
  if (values.csv) {
    parse(values.csv, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const missingFields = headerValidation(results.meta.fields, requiredFields);
        setOpen(Boolean(missingFields?.length > 0));
        setMissingFields(missingFields);
      }
    });
  }
};
